import { render, staticRenderFns } from "./PdfViewerDialog.vue?vue&type=template&id=66b7f475&scoped=true&"
import script from "./PdfViewerDialog.vue?vue&type=script&lang=js&"
export * from "./PdfViewerDialog.vue?vue&type=script&lang=js&"
import style0 from "./PdfViewerDialog.vue?vue&type=style&index=0&id=66b7f475&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b7f475",
  null
  
)

export default component.exports